"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commons = require("../commons");

var ColorsFixed = _react["default"].forwardRef(function (_props, ref) {
  var colorsRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        colorsRef.current.focus();
      },
      click: function click() {
        colorsRef.current.click();
      },
      blur: function blur() {
        colorsRef.current.blur();
      }
    };
  });
  return _react["default"].createElement(_commons.DefaultColors, {
    ref: colorsRef
  });
});

var _default = ColorsFixed;
exports["default"] = _default;